<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                :style="($i18n.locale == 'ar') ? '' : 'text-align: left'">
                {{ $t('app.choose_companies') }}
            </h4>
            <div class="col-md-12 text-center" style="padding:0">
                <span 
                    v-if="companiesLoading"
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span>
                <select 
                    v-if="!companiesLoading"
                    id="transactionType"
                    class="form-control" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.company_id"
                    v-on:change="onInputChange">
                    <option 
                        v-for="(row, idx) in companies" 
                        :key="idx"
                        :value="row.id">
                        {{ ($i18n.locale == 'ar') ? row.ar.title : row.en.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>
        
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'CardCompany',
    props: [
        'company_id'
    ],
    data(){
        return {
            auth: {
                access_token: ''
            },
            row: {
                company_id: this.$props.company_id
            },
            companies: [],
            companiesLoading: true,
        }
    },
    mounted() {},
    created() {
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchData();
    },
    methods: {
        onInputChange(){
            const data = {
                company_id: this.row.company_id
            }
            this.$emit('companyChange', data);
        },

        fetchData() {
            this.companiesLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/companies',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.companiesLoading = false;
                this.companies = res.data.data.rows;
            })
            .catch(err => {
                this.companiesLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },
    }
}
</script>
